<template>
  <div v-if="sectionInfo && isVisible && !isLoading" :class="'multi' + ' ' + thumbnailInfo.componentName" :style="multiSectionColor" v-on-display="{sectionInfo, context: this}">
    <div class="title">
      <h1 v-band-title class="title-area" tabindex="0">
        <span class="label">{{multiSectionTitle}}</span>
      </h1>
    </div>
    <lazy-component v-if="hasSchedule">
      <baseball-schedule-cell-list :cell-list="cellList" :thumbnail-info="thumbnailInfo">
      </baseball-schedule-cell-list>
    </lazy-component>
    <empty-schedule-today v-else></empty-schedule-today>

    <a v-if="hasViewMore" href="#" @click.prevent="moveToSchedule()" class="btn-more all">{{viewMoreTitle(sectionInfo, '전체보기')}}</a>
  </div>
</template>

<script>
  import { bandTitle, onDisplay } from '@/common/resources/directives'
  import { fetchOnContent } from '@/common/utils/request.common'
  import { getBand, getCellList } from '@/common/utils/gnb.fp'
  import MultiSectionMixin from '@/mixins/multisection.mixin'
  import BaseballScheduleCellList from '@/components/band/BaseballScheduleCellList'
  import EmptyScheduleToday from '@/components/model/cell/EmptyScheduleToday'
  import _ from 'lodash'
  import { PATH_NAME_BASEBALL_SCHEDULE } from '@/common/resources/router.const'
  export default {
    name: 'TemplateMultiSection',
    mixins: [
      MultiSectionMixin
    ],
    directives: {
      bandTitle,
      onDisplay
    },
    components: {
      BaseballScheduleCellList,
      EmptyScheduleToday
    },
    props: {
      sectionInfo: {
        type: Object
      },
      thumbnailInfo: {
        type: Object
      }
    },
    data () {
      return {
        bandInfo: null,
        cellList: [],
        isVisible: true,
        isLoading: true,
        hasSchedule: false
      }
    },
    methods: {
      async setData () {
        this.isLoading = true
        if (this.cellList.length !== 0) return
        const response = await fetchOnContent(this.sectionInfo)
        this.bandInfo = getBand(response)
        this.cellList = getCellList(response)
        if (this.cellList.length === 0) { this.isVisible = false }
        this.hasSchedule = _.get(response, 'data.band.game_count', 0) > 0
        this.isLoading = false
      },
      moveToSchedule () {
        this.$router.push({ name: PATH_NAME_BASEBALL_SCHEDULE })
      }
    },
    created () {
      this.setData()
    }
  }
</script>

<style lang="css" scoped>
  .multi.landscape-cell {
    min-height: 238px;
  }
  .multi.circle-cell {
    min-height: 202px;
  }
  .multi.portrait-cell {
    min-height: 383px;
  }
</style>
